(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasFinePointer = window.matchMedia('(pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Scroll reveal: sections, cards, tables ---------- */
  function initReveal() {
    if (reduceMotion || !hasIO) return;

    // The Bumli hero (product.json template) gets its own instant "snap" reveal
    // via initSnapReveal() below, so it's excluded here to avoid a double animation.
    var snapEl = document.querySelector('main[data-template="product"] [data-testid="media-with-content"]');

    // The Domino hero (product.domino.json template) gets its own "roll-in" reveal
    // via initDominoHeroRoll() below, so its outer section wrapper is excluded here
    // (the text half still gets the normal reveal via the content selector).
    var dominoHeroMedia = document.querySelector('main[data-template="product.domino"] [data-testid="media-with-content"]');
    var dominoHeroSection = dominoHeroMedia ? dominoHeroMedia.closest('.shopify-section') : null;

    var targets = Array.prototype.filter.call(
      document.querySelectorAll(
        [
          '#MainContent .shopify-section',
          '[data-testid="media-with-content"] .media-with-content__content',
          '#MainContent table',
          '#MainContent [class*="product-card"]'
        ].join(', ')
      ),
      function (el) {
        if (snapEl && (el === snapEl || snapEl.contains(el) || el.contains(snapEl))) return false;
        if (dominoHeroSection && el === dominoHeroSection) return false;
        return true;
      }
    );
    if (!targets.length) return;

    targets.forEach(function (el, i) {
      el.classList.add('fx-reveal', 'fx-reveal-' + ((i % 4) + 1));
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fx-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Snap reveal: Bumli hero image+text block appears instantly ---------- */
  function initSnapReveal() {
    if (reduceMotion || !hasIO) return;

    var el = document.querySelector('main[data-template="product"] [data-testid="media-with-content"]');
    if (!el) return;

    el.classList.add('fx-reveal-snap');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fx-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(el);
  }

  /* ---------- Roll-in reveal: Domino hero image rolls into place ---------- */
  function initDominoHeroRoll() {
    if (reduceMotion || !hasIO) return;

    var media = document.querySelector('main[data-template="product.domino"] [data-testid="media-with-content"]');
    if (!media) return;
    var el = media.querySelector('.media-block') || media;

    el.classList.add('fx-roll-in');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fx-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(el);
  }

  /* ---------- Icon micro entrance (benefit + trust icons) ---------- */
  function initIconReveal() {
    if (reduceMotion || !hasIO) return;

    var icons = document.querySelectorAll(
      '#MainContent [style*="font-size: 26px"], #MainContent [style*="font-size:26px"]'
    );
    if (!icons.length) return;

    icons.forEach(function (el) {
      el.classList.add('fx-icon-reveal');
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var group = icons.length ? Array.prototype.indexOf.call(icons, el) : 0;
          setTimeout(function () {
            el.classList.add('fx-in');
          }, (group % 6) * 80);
          io.unobserve(el);
        });
      },
      { threshold: 0.3 }
    );

    icons.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Comparison table: staggered row reveal ---------- */
  function initTableRows() {
    if (reduceMotion || !hasIO) return;

    var tables = document.querySelectorAll('#MainContent table');
    if (!tables.length) return;

    tables.forEach(function (table) {
      var rows = table.querySelectorAll('tbody tr');
      rows.forEach(function (row, i) {
        row.style.opacity = '0';
        row.style.transform = 'translateY(10px)';
        row.style.transition =
          'opacity 0.5s ease ' + (i * 0.08) + 's, transform 0.5s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.08) + 's';
      });

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            rows.forEach(function (row) {
              row.style.opacity = '1';
              row.style.transform = 'translateY(0)';
            });
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );
      io.observe(table);
    });
  }

  /* ---------- Gentle float on one lifestyle image ---------- */
  function initFloat() {
    if (reduceMotion) return;

    var galleryImgs = document.querySelectorAll(
      '#MainContent product-media-gallery img, #MainContent [class*="media-gallery"] img'
    );
    var target = galleryImgs && galleryImgs.length > 1 ? galleryImgs[1] : galleryImgs[0];
    if (target) target.classList.add('fx-float');
  }

  /* ---------- Lightweight parallax on the hero image only ---------- */
  function initParallax() {
    if (reduceMotion || !hasFinePointer) return;

    var hero = document.querySelector('[data-testid="media-with-content"] .media-block');
    if (!hero) return;
    var img = hero.querySelector('img');
    if (!img) return;

    img.classList.add('fx-parallax');

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom > 0 && rect.top < viewportH) {
        var progress = (viewportH - rect.top) / (viewportH + rect.height);
        var offset = (progress - 0.5) * 40;
        img.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.08)';
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function start() {
    initReveal();
    initSnapReveal();
    initDominoHeroRoll();
    initIconReveal();
    initTableRows();
    initFloat();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();